/* VOID Quick Add
   - <quick-add-void> wraps the (+) button on each product card.
   - Single-variant products add straight to cart and open Dawn's <cart-drawer>.
   - Multi-size products open a shared side/bottom drawer populated by the
     'quick-add-drawer' section; add-to-cart there is handled by Dawn's
     <product-form>, which re-renders and opens the cart drawer.
*/
(function () {
  if (window.__voidQuickAddInitialized) return;
  window.__voidQuickAddInitialized = true;
  document.documentElement.setAttribute('data-qav-ready', 'true');

  var SECTION = 'quick-add-drawer';

  function getCartDrawer() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function openExistingCart() {
    var cart = getCartDrawer();
    if (cart && typeof cart.open === 'function') {
      cart.open();
      return;
    }

    // UpCart owns this host element. Clicking it uses the app's public UI path
    // without depending on private globals or replacing its event handlers.
    var upcartToggle = document.querySelector('#upCartStickyButton');
    if (upcartToggle && typeof upcartToggle.click === 'function') {
      upcartToggle.click();
      return;
    }

    // Let other cart apps refresh without forcing a page navigation.
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
  }

  /* ---- Shared size drawer (built once, lazily) ---- */
  function SizeDrawer() {
    this.el = null;
    this.content = null;
  }
  SizeDrawer.prototype.ensure = function () {
    if (this.el) return this.el;
    var wrap = document.createElement('div');
    wrap.className = 'qav-drawer';
    wrap.id = 'QuickAddVoidDrawer';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML =
      '<div class="qav-drawer__overlay" data-qav-overlay></div>' +
      '<div class="qav-drawer__panel" tabindex="-1">' +
      '<button type="button" class="qav-drawer__close" data-qav-close aria-label="Close">' +
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<div class="qav-drawer__content" data-qav-content></div>' +
      '</div>';
    document.body.appendChild(wrap);
    this.el = wrap;
    this.content = wrap.querySelector('[data-qav-content]');

    var self = this;
    wrap.querySelector('[data-qav-overlay]').addEventListener('click', function () { self.close(); });
    wrap.querySelector('[data-qav-close]').addEventListener('click', function () { self.close(); });
    document.addEventListener('keyup', function (e) {
      if (e.code === 'Escape' && self.isOpen()) self.close();
    });
    this.content.addEventListener('click', function (e) {
      var checkout = e.target.closest('[data-qav-checkout]');
      if (checkout && !checkout.disabled) {
        e.preventDefault();
        self.checkout(checkout);
        return;
      }
      var pill = e.target.closest('[data-qav-option]');
      if (pill) self.selectOption(pill);
      var add = e.target.closest('[data-qav-add]');
      if (add && !add.disabled) {
        self.close();
        window.setTimeout(openExistingCart, 900);
      }
    });
    this.content.addEventListener('submit', function (e) {
      if (!e.target.closest('.qav-panel__form')) return;
      window.setTimeout(function () {
        self.close();
        openExistingCart();
      }, 900);
    });
    return wrap;
  };
  SizeDrawer.prototype.isOpen = function () {
    return !!this.el && this.el.classList.contains('is-open');
  };
  SizeDrawer.prototype.open = function () {
    this.ensure();
    this.el.setAttribute('aria-hidden', 'false');
    void this.el.offsetHeight; /* reflow so the transition runs */
    this.el.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
  };
  SizeDrawer.prototype.close = function () {
    if (!this.el) return;
    this.el.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  };
  SizeDrawer.prototype.setLoading = function () {
    this.ensure();
    this.content.innerHTML =
      '<div class="qav-drawer__loading"><svg class="qav-spin" viewBox="0 0 66 66">' +
      '<circle cx="33" cy="33" r="30" fill="none" stroke="currentColor" stroke-width="4" stroke-dasharray="120 40"/></svg></div>';
  };
  SizeDrawer.prototype.load = function (productUrl) {
    var self = this;
    this.ensure();
    this.setLoading();
    this.open();
    var url = productUrl + (productUrl.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + SECTION;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var panel = doc.querySelector('[data-qav-panel]');
        self.content.innerHTML = panel ? panel.outerHTML : '<p class="qav-drawer__error">Unable to load options.</p>';
        self.initPaymentButton();
      })
      .catch(function (e) {
        console.error('[quick-add-void]', e);
        self.content.innerHTML = '<p class="qav-drawer__error">Something went wrong. Please try again.</p>';
      });
  };
  SizeDrawer.prototype.initPaymentButton = function () {
    if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
      try { window.Shopify.PaymentButton.init(); } catch (e) {}
    }
  };
  SizeDrawer.prototype.selectOption = function (pill) {
    if (pill.getAttribute('aria-disabled') === 'true') return;
    var panel = this.content.querySelector('[data-qav-panel]');
    var group = pill.closest('[data-qav-option-group]');
    if (!panel || !group) return;

    group.querySelectorAll('[data-qav-option]').forEach(function (button) {
      var selected = button === pill;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    var data = panel.querySelector('[data-qav-variant-data]');
    var variants = [];
    try { variants = JSON.parse(data ? data.textContent : '[]'); } catch (e) {}

    var groups = Array.from(panel.querySelectorAll('[data-qav-option-group]'))
      .sort(function (a, b) { return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition); });
    var selectedValues = groups.map(function (optionGroup) {
      var selectedButton = optionGroup.querySelector('[data-qav-option].is-selected');
      return selectedButton ? selectedButton.dataset.optionValue : '';
    });

    panel.querySelectorAll('[data-qav-option]').forEach(function (button) {
      var position = Number(button.dataset.optionPosition) - 1;
      var value = button.dataset.optionValue;
      var hasAvailableVariant = variants.some(function (variant) {
        return variant.available && variant.options[position] === value;
      });
      button.classList.toggle('is-soldout', !hasAvailableVariant);
      button.setAttribute('aria-disabled', hasAvailableVariant ? 'false' : 'true');
    });

    var variant = variants.find(function (item) {
      return item.options.length === selectedValues.length && item.options.every(function (value, index) {
        return value === selectedValues[index];
      });
    });
    var available = !!(variant && variant.available);
    var idInput = panel.querySelector('[data-qav-variant-id]');
    if (idInput) idInput.value = variant ? variant.id : '';

    var summary = panel.querySelector('[data-qav-summary]');
    if (summary) summary.textContent = selectedValues.filter(Boolean).join(' / ');

    var addBtn = panel.querySelector('[data-qav-add]');
    var addText = panel.querySelector('[data-qav-add-text]');
    if (addBtn) {
      addBtn.disabled = !available;
      if (addText) addText.textContent = available ? addBtn.dataset.textAdd : addBtn.dataset.textSoldout;
    }
    var checkoutBtn = panel.querySelector('[data-qav-checkout]');
    if (checkoutBtn) checkoutBtn.disabled = !available;
  };

    SizeDrawer.prototype.checkout = function (button) {
    var panel = this.content.querySelector('[data-qav-panel]');
    var idInput = panel && panel.querySelector('[data-qav-variant-id]');
    var variantId = idInput && idInput.value;
    if (!variantId) return;

    button.disabled = true;
    button.classList.add('is-loading');

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) { throw data; });
        }
        return response.json();
      })
      .then(function () {
        window.location.assign('/checkout');
      })
      .catch(function (error) {
        console.error('[quick-add-void checkout]', error);
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  };

  var drawer = new SizeDrawer();

  document.addEventListener('click', function (event) {
    var add = event.target.closest && event.target.closest('#QuickAddVoidDrawer [data-qav-add]');
    if (!add || add.disabled) return;
    drawer.close();
    window.setTimeout(openExistingCart, 900);
  }, true);

  /* Close the size drawer once an add succeeds (product-form publishes cartUpdate). */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'product-form' && drawer.isOpen()) {
        drawer.close();
        window.setTimeout(openExistingCart, 0);
      }
    });
  }

  /* ---- Card button element ---- */
  if (!customElements.get('quick-add-void')) {
    customElements.define(
      'quick-add-void',
      class QuickAddVoid extends HTMLElement {
        constructor() {
          super();
          this.setAttribute('data-qav-bound', 'true');
          this.btn = this.querySelector('.qav__btn');
          this.mode = this.dataset.mode;
          if (this.btn) this.btn.addEventListener('click', this.onClick.bind(this));
        }
        onClick(e) {
          e.preventDefault();
          e.stopPropagation();
          if (this.mode === 'single') this.addSingle();
          else if (this.mode === 'multi') drawer.load(this.dataset.productUrl);
          else window.location = this.dataset.productUrl;
        }
        setLoading(on) {
          if (!this.btn) return;
          this.btn.classList.toggle('is-loading', on);
          this.btn.disabled = on;
          var sp = this.querySelector('.qav__spinner');
          if (sp) sp.hidden = !on;
        }
        addSingle() {
          var self = this;
          var cart = getCartDrawer();
          var id = this.dataset.variantId;
          if (!id) { window.location = this.dataset.productUrl; return; }
          this.setLoading(true);

          var formData = new FormData();
          formData.append('id', id);
          formData.append('quantity', 1);
          if (cart && typeof cart.getSectionsToRender === 'function') {
            formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
            formData.append('sections_url', window.location.pathname);
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(this.btn);
          }

          fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          })
            .then(function (r) { return r.json(); })
            .then(function (response) {
              if (response.status) {
                console.warn('[quick-add-void] add error', response);
                window.location = self.dataset.productUrl;
                return;
              }
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add-void', productVariantId: id, cartData: response });
              }
              if (cart && typeof cart.renderContents === 'function') {
                cart.renderContents(response);
              } else {
                openExistingCart();
              }
            })
            .catch(function (e) { console.error('[quick-add-void]', e); })
            .finally(function () { self.setLoading(false); });
        }
      }
    );
  }

  // Hide quick add until a scheduled product window opens.
const qavPruneComingSoon = (root = document) => {
  root.querySelectorAll('.card-wrapper').forEach((card) => {
    const badge = card.querySelector('[data-product-card-window-badge][data-window-start]');
    const quickAdd = card.querySelector('quick-add-void');
    const opensAt = Number(badge?.dataset.windowStart) * 1000;
    if (quickAdd && opensAt && opensAt > Date.now()) quickAdd.remove();
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => qavPruneComingSoon());
} else {
  qavPruneComingSoon();
}
document.addEventListener('shopify:section:load', (event) => qavPruneComingSoon(event.target));
})();
